<template>
  <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
  >
    <template #title>
      {{ $t("orderBy") }}
      <a-select
          ref="order"
          v-model:value="page.order"
          style="width: 150px;display: inline-block"
          allowClear
          showSearch
          optionFilterProp="name"
          @change="changeOrder"
      >
        <a-select-option v-for="item in orderList" v-model:value="item.key" :key="item.key" :name="item.name">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <div style="display: inline-block;margin-left: 10px">
        <a-radio-group v-model:value="page.sortType" @change.stop="changeOrder">
          <a-radio-button value="back">
            <arrow-up-outlined/>
          </a-radio-button>
          <a-radio-button value="normal">
            <arrow-down-outlined/>
          </a-radio-button>
        </a-radio-group>
      </div>
    </template>
    <template #extra>
      <a-pagination
          style="display: inline-block"
          :total="total"
          v-model:current="page.current"
          v-model:pageSize="page.pageSize"
          :page-size-options="page.pageSizeOptions"
          show-size-changer
          :show-total="total => `${$t('total')} ${total} ${$t('items')}`"
          @showSizeChange="onShowSizeChange"
          @change="changePage"
      />
    </template>

  </a-page-header>

</template>

<script>
import {
  ArrowUpOutlined,
  ArrowDownOutlined
} from '@ant-design/icons-vue';

export default {
  name: "v-page",
  props: {
    total: Number,
    orderList: [],
  },
  components: {
    ArrowUpOutlined,
    ArrowDownOutlined
  },
  data() {
    return {
      page: {
        current: 1,
        total: this.total,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100', '500', '1000'],
        sortType: "back",
        order: "",
      },
    }
  },
  methods: {
    onShowSizeChange(current, pageSize) {
      this.page.current = 1;
      this.page.pageSize = pageSize;
      this.$emit("pageChange", this.page);
    },
    changePage(page, pageSize) {
      this.page.pageSize = pageSize;
      this.page.current = page;
      this.$emit("pageChange", this.page);
    },
    changeOrder() {
      this.$emit("pageChange", this.page)
    }
  }
}
</script>

<style scoped>

</style>